export default {
    'name': 'familySearchOverview',
    'getComponent': () => import('./FamilySearchOverview.vue'),
    'tabIndex': 0,
    'left': false,
    'right': false,
    'singleView': true,
    'compareView': false,
    'exclusiveRoutePath': '/familySearchOverview',
    'enableDensity': false,
    'selfHandelPadding': true,
};
